import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NameSpace } from '../../const';
import { ReportFactory } from '../../types/state';
import { FetchReportFactoryParams, FetchReportFactorySuccessPayload } from '../../types/request';
import { buildReportFactory } from '../../utils/data-table';

const initialState: ReportFactory = {
  data: null,
  fetchingStatusReportFactory: false,
  error: null
};

export const dataReportFactoryVPO = createSlice({
  name: NameSpace.ReportFactory,
  initialState,
  reducers: {
    fetchReportFactoryRequestVPO: (state, payload: PayloadAction<FetchReportFactoryParams>) => {
      state.fetchingStatusReportFactory = true;
      state.error = null;
    },
    fetchReportFactorySuccessVPO: (state, action: PayloadAction<FetchReportFactorySuccessPayload>) => {
      state.fetchingStatusReportFactory = false;
      const data = action.payload;
      console.log('fetchReportFactorySuccessVPO', action.payload)
      state.data = buildReportFactory(data, data.params.group[0]);
    },
    fetchReportFactoryFailureVPO: (state, action) => {
      state.fetchingStatusReportFactory = false;
      state.error = action.payload;
    },
  },
});

export const { fetchReportFactoryRequestVPO, fetchReportFactorySuccessVPO, fetchReportFactoryFailureVPO } = dataReportFactoryVPO.actions;
